import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=71f5b712&scoped=true&lang=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5b712",
  null
  
)

export default component.exports